import { CRAWL_REQUEST_API_PREFIX } from '@aibees/elephant/constants';
import {
  CrawlRequestGrouping,
  CrawlRequestStatus,
  CrawlRow,
} from '@aibees/elephant/types/crawl-request';
import {
  PaginationRequest,
  PaginationResponse,
} from '@aibees/shared/definition';
import { QueryOptions } from '@aibees/shared/http';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';

export interface BrowseCrawlRequestsRequest
  extends PaginationRequest<{
    value?: string;
    status?: CrawlRequestStatus | string;
    grouping?: CrawlRequestGrouping;
    id?: string;
  }> {}

export function useBrowseCrawlRequestsApi(
  params: BrowseCrawlRequestsRequest,
  options?: QueryOptions
) {
  params.page = params.page || 0;
  params.size = params.size || 20;
  const { status, value, grouping, page, size, sort, id } = params;
  const workspaceId = useWorkspace()?.id;

  return useBaseQuery<typeof params, PaginationResponse<CrawlRow>>(
    [
      useBrowseCrawlRequestsApi.name,
      status,
      value,
      grouping,
      sort,
      page,
      size,
      id,
    ],
    {
      url: CRAWL_REQUEST_API_PREFIX.replace(':wid', String(workspaceId)),
      params: {
        status,
        value,
        grouping,
        page,
        size,
        sort,
        id,
      },
    },
    options
  );
}
